import Card from '@mui/material/Card';
import Grid from '@mui/material/GridLegacy';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import CloseIcon from '../../icons/Actions/CloseIcon';
import CheckIcon from '../../icons/Alerts/CheckIcon';
import ErrorIcon from '../../icons/Alerts/ErrorIcon';
import InfoIcon from '../../icons/Alerts/InfoIcon';
import WarningIcon from '../../icons/Alerts/WarningIcon';
import { withStyles } from '../../styles/tools';
import { withTrace } from '../../utils';
import { styles, useStyles } from './Notification.styles';
import { NotificationType } from './Notification.types';
export const StatusIcon = ({ type }) => {
    let retval = React.createElement(InfoIcon, null);
    switch (type) {
        case NotificationType.SUCCESS:
        case NotificationType.SUCCESS_LIGHT:
            retval = React.createElement(CheckIcon, null);
            break;
        case NotificationType.ERROR:
        case NotificationType.ERROR_LIGHT:
            retval = React.createElement(ErrorIcon, null);
            break;
        case NotificationType.WARNING:
        case NotificationType.WARNING_LIGHT:
            retval = React.createElement(WarningIcon, null);
    }
    return retval;
};
export const IconComponent = (props) => {
    const { classes, type, description, applyTrace, children } = props;
    const iconClasses = classnames({
        [classes.infoBackground]: type === NotificationType.INFO_LIGHT,
    }, classes.statusIcon, classes[type]);
    const iconFormat = classnames({
        [classes.iconWrapperDescription]: description && !children,
        [classes.iconWrapperDescriptionChildren]: description && children,
    }, classes.iconWrapper);
    return (React.createElement(Grid, Object.assign({ item: true, className: iconClasses }, applyTrace(`icon-${type}`)),
        React.createElement(Grid, { container: true, className: iconFormat },
            React.createElement(StatusIcon, Object.assign({}, props)))));
};
export const MessageComponent = (props) => {
    const { classes, message, messageComponent, description, type, applyTrace, closeCallback, children, inlineChildren = false, } = props;
    const messageStyle = classnames({
        [classes.infoBackground]: type === NotificationType.INFO_LIGHT && description,
        [classes.defaultBackground]: type !== NotificationType.INFO_LIGHT && description,
    });
    const descriptionStyle = classnames({
        [classes.notificationMessageDescription]: description && !children,
        [classes.notificationMessageChildren]: description && children,
    }, classes.notificationMessage);
    const renderMessageAndInlineChildren = () => (React.createElement(Grid, { container: true, alignItems: "center", style: { height: '100%' } },
        React.createElement(Grid, { item: true, xs: true },
            React.createElement(Grid, { flexDirection: "column" },
                React.createElement(Typography, Object.assign({ className: classes.contentText }, applyTrace('message'), { component: messageComponent !== null && messageComponent !== void 0 ? messageComponent : 'p' }), message),
                React.createElement("div", { style: { alignSelf: 'self-start' } }, children)))));
    const renderMessageAsHeading = () => (React.createElement(Grid, { container: true, alignItems: "center" },
        React.createElement(Grid, { item: true, xs: true },
            React.createElement(Typography, Object.assign({ variant: "h5" }, applyTrace('message')), message))));
    const renderMessage = () => (React.createElement(Grid, { container: true, alignItems: "center", style: { height: '100%' } },
        React.createElement(Grid, { item: true, xs: true },
            React.createElement(Typography, Object.assign({ className: classes.contentText }, applyTrace('message'), { component: messageComponent !== null && messageComponent !== void 0 ? messageComponent : 'p' }), message))));
    const renderContent = () => {
        if (inlineChildren && children) {
            return renderMessageAndInlineChildren();
        }
        if (description) {
            return renderMessageAsHeading();
        }
        return renderMessage();
    };
    const renderDescription = () => (React.createElement(Grid, { container: true, alignItems: "center" },
        React.createElement(Grid, { item: true, xs: true },
            React.createElement(Typography, Object.assign({ variant: "body2" }, applyTrace('description')), description))));
    const renderCloseButton = () => (React.createElement(Grid, { item: true },
        React.createElement(IconButton, Object.assign({ onClick: closeCallback, className: classes.closeButton }, applyTrace('close-button'), { size: "large" }),
            React.createElement(CloseIcon, { fontSize: "inherit" }))));
    return (React.createElement(Grid, { container: true, alignItems: "stretch", wrap: "nowrap", className: messageStyle },
        React.createElement(Grid, { xs: true, item: true, className: descriptionStyle },
            renderContent(),
            description && renderDescription()),
        closeCallback && renderCloseButton()));
};
export const NotificationBase = forwardRef((props, ref) => {
    const { children, closeCallback = null, applyTrace, inlineChildren = false } = props;
    const { classes } = useStyles(undefined, { props: { classes: props.classes } });
    const propsForChildren = Object.assign(Object.assign({}, props), { classes, inlineChildren });
    const rootStyle = classnames({
        [classes.boxShadow]: closeCallback !== null,
        [classes.border]: closeCallback === null,
    }, classes.root);
    return (React.createElement(Card, Object.assign({ ref: ref, variant: "outlined", square: true }, applyTrace('root'), { className: rootStyle }),
        React.createElement(Grid, { container: true, alignItems: "stretch", wrap: "nowrap" },
            React.createElement(IconComponent, Object.assign({}, propsForChildren)),
            React.createElement(MessageComponent, Object.assign({}, propsForChildren))),
        !inlineChildren && children && (React.createElement(Grid, Object.assign({ item: true, className: classes.childrenStyle }, applyTrace('children')), children))));
});
const traced = withTrace('notification')(NotificationBase);
export const Notification = withStyles(styles)(traced);
//# sourceMappingURL=Notification.js.map